/*
 * Copyright (c) 2000-2022 TeamDev. All rights reserved.
 * TeamDev PROPRIETARY and CONFIDENTIAL.
 * Use is subject to license terms.
 */

/**
 * An object that defines a group of records.
 *
 * Records are divided into groups by assigning a `GroupDef` object to each record, according to
 * the record's content, depending on the grouping algorithm. Then, the records that were associated
 * with the same group definition are combined for displaying together.
 *
 * Note that `GroupDef` doesn't contain the records but just denotes a group.
 *
 * Pattern-wise, `GroupDef`s are immutable value objects, which practically means that there can be
 * multiple `GroupDef` objects that denote the same group. By convention, `GroupDef` objects denote
 * the same group if their `id` properties are equal.
 */
export abstract class GroupDef {

  /**
   * A unique identifier for this group. Doesn't need to have any semantics, used for distinguishing
   * between groups and more efficient UI updates.
   */
  abstract get id(): string | number;

  /**
   * A human readable group title.
   */
  abstract get title(): string;
}
